import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/tehnipedia.png'


const _hoisted_1 = /*#__PURE__*/_createTextVNode("Pagina Principala ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Articole ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Tehnipedia ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Administrare")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Parametri sistem")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Banner")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Companii")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Utilizatori")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Categorii")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Articole")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Tipuri")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Profilul meu ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Log out ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(_component_q_item, {
      clickable: "",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToView('Dashboard')))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { avatar: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              color: "primary",
              name: "dashboard"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_directive_ripple]
    ]),
    _withDirectives(_createVNode(_component_q_item, {
      clickable: "",
      onClick: _ctx.onGoToBrowseCategories
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { avatar: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              color: "primary",
              name: "category"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"]), [
      [_directive_ripple]
    ]),
    _withDirectives(_createVNode(_component_q_item, {
      clickable: "",
      onClick: _ctx.openTehnipedia
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { avatar: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, { color: "primary" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"]), [
      [_directive_ripple]
    ]),
    (_ctx.user.isAdmin=='y')
      ? (_openBlock(), _createBlock(_component_q_separator, {
          key: 0,
          inset: ""
        }))
      : _createCommentVNode("", true),
    (_ctx.user.isAdmin=='y')
      ? (_openBlock(), _createBlock(_component_q_item_label, {
          key: 1,
          header: ""
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.user.isAdmin=='y')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 2,
          clickable: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToView('AdminSystemParameters')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  color: "primary",
                  name: "settings"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.isAdmin=='y')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 3,
          clickable: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToView('AdminBanner')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  color: "primary",
                  name: "image"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.isAdmin=='y')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 4,
          clickable: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToView('AdminCompanies')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  color: "primary",
                  name: "apartment"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.isAdmin=='y')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 5,
          clickable: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToView('AdminUsers')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  color: "primary",
                  name: "group_add"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.isAdmin=='y')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 6,
          clickable: "",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToView('AdminCategory')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  color: "primary",
                  name: "qr_code"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.isAdmin=='y')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 7,
          clickable: "",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToView('AdminArticles')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  color: "primary",
                  name: "qr_code"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    (_ctx.user.isAdmin=='y')
      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          key: 8,
          clickable: "",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToView('AdminTipuri')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  color: "primary",
                  name: "qr_code"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)), [
          [_directive_ripple]
        ])
      : _createCommentVNode("", true),
    _createVNode(_component_q_separator, { inset: "" }),
    _withDirectives(_createVNode(_component_q_item, {
      clickable: "",
      onClick: _ctx.goToMyProfile
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { avatar: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              color: "primary",
              name: "sentiment_satisfied_alt"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"]), [
      [_directive_ripple]
    ]),
    _withDirectives(_createVNode(_component_q_item, {
      clickable: "",
      onClick: _ctx.logout
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_item_section, { avatar: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_icon, {
              color: "primary",
              name: "logout"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_item_section, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_label, null, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClick"]), [
      [_directive_ripple]
    ])
  ]))
}